module.exports = __webpack_public_path__ + "static/media/roundaboutCW180.cfbeb3f9.svg";